import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const getMySummaryCompetencyApi = ({
  limit = 3,
  offset = 0,
  employeeId,
  isCompetencyDescriptionRequired = false,
  isPreview,
}) => {
  const url = endpoints.home.mySummary.competency(employeeId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      isCompetencyDescriptionRequired,
      isPreview,
    },
  });
};
